module.exports = __webpack_public_path__ + "img/head_nine.bc37c11d.png";